/* TODO: need to remove Ractive library */
import Ractive from '../modules/ractive'
import fade from 'ractive-transitions-fade'
import bindAll from 'lodash/bindAll'

const spiral = window.spiral

export default class FavoritesModal {
  static run () {
    return new FavoritesModal()
  }

  constructor () {
    this.portalDomain = window.portalDomain
    this.collections = []
    this.isCreatedCollection = null
    bindAll(this, ['bindAjax', 'loadingCollections', 'init'])
    this.isPersonal = (window.isPersonalUploads) ? 1 : null
    this.isDepositPhotos = (window._isDepositPhotosPage_) ? 1 : null
    this.isIcons8 = (window._isIcons8Page_) ? 1 : null
    // this.assetType - To identify the product type
    this.assetType = (window.assetType) ? window.assetType : null


    $(document).on('click', '.js-add-to-favorites', this.loadingCollections)

    window.cbCreateCollection = result => {
      if (result.response.status === 201) {
        this.isCreatedCollection = true
        this.rv.set('collections', result.response.collections)
        this.rv.set('savedCollections', $.extend(true, {}, result.response.collections))
        this.rv.set('titleNew', '')
      }
    }
  }

  loadingCollections (event) {
    event.preventDefault()
    const $btn = $(event.target).closest('.js-add-to-favorites')
    const id = $btn.data('id')
    const productType = $(this).data('product-type')

    this.bindAjax(id, productType, () => this.init($btn, productType, id))
  }

  init (btn, productType, productID) {
    const that = this

    this.rv = new Ractive({
      el: document.body,
      append: true,
      template: '#tpl-collections',
      transitions: { fade },
      data: {
        productID,
        collections: that.collections,
        portalDomain: window.portalDomain,
        isPersonal: that.isPersonal,
        isDepositPhotos: that.isDepositPhotos,
        isIcons8: that.isIcons8,
        savedCollections: $.extend(true, {}, that.collections),
        assetType: that.assetType,
      },
      onrender () {
        const rv = this

        const isPersonalProductType = (productType === 'personal' ? 1 : null)
        const isDPProductType = (productType === 'dp' ? 1 : null)
        const isIcons8ProductType = (productType === 'icons8' ? 1 : null)

        rv.on('close', () => {
          const collections = rv.get('collections') || []

          collections.forEach((collection, i) => {
            const hasProduct = collection.hasProduct

            if (hasProduct === rv.get(`savedCollections.${i}.hasProduct`)) {
              return
            }

            collection.hasProduct = rv.get(`savedCollections.${i}.hasProduct`)
            collection.countProducts = rv.get(`savedCollections.${i}.countProducts`)
          })
          rv.teardown()
        })

        rv.on('submit', () => {
          that.collections = rv.get('collections') || []
          let addedToFavorites

          that.collections.forEach((collection, i) => {
            const hasProduct = collection.hasProduct

            if (hasProduct) {
              addedToFavorites = true
            }

            const countProducts = collection.countProducts
            const collectionID = rv.get(`collections.${i}.id`)

            if (hasProduct === rv.get(`savedCollections.${i}.hasProduct`)) {
              return
            }

            spiral.ajax({
              url: `/collections/${hasProduct ? 'addProduct' : 'removeProduct'}/${productID}`,
              data: {
                collectionID,
                personal: that.isPersonal || isPersonalProductType,
                dp: that.isDepositPhotos || isDPProductType,
                icons8: that.isIcons8 || isIcons8ProductType,
                assetType: that.assetType,
              },
              processAnswer (result) {
                if (result.response.status === 200) {
                  rv.set(`collections.${i}.hasProduct`, hasProduct)
                  rv.set(`collections.${i}.countProducts`, countProducts)
                  rv.set('savedCollections', $.extend(true, {}, rv.get('collections')))
                } else {
                  rv.set(`collections.${i}.hasProduct`, !hasProduct)
                }
              },
            })
          })

          const closestItem = btn.closest('.item')

          if (closestItem.length) {
            if (addedToFavorites && !btn.closest('.item').find('.product-dot--orange').length) {
              closestItem.find('.product-status').prepend('<span class="product-dot product-dot--orange"></span>')
              closestItem.find('.js-add-to-favorites').addClass('favorites-remove')
            } else if (!addedToFavorites && btn.closest('.item').find('.product-dot--orange').length) {
              closestItem.find('.product-popup__status').find('.favorite').remove()
              closestItem.find('.product-status').find('.product-dot--orange').remove()
              closestItem.find('.js-add-to-favorites').removeClass('favorites-remove')
            }
          } else {
            if (addedToFavorites) {
              $('.js-add-to-favorites').addClass('favorites-remove')
            } else {
              $('.js-add-to-favorites').removeClass('favorites-remove')
            }
          }

          rv.teardown()
        })

        rv.observe('collections.*.hasProduct', (val, old, kp, i) => {
          if (that.isCreatedCollection) {
            that.isCreatedCollection = false
          } else {
            if (typeof old === 'undefined' || typeof val === 'undefined') {
              return
            }

            rv.add(`collections.${i}.countProducts`, val ? 1 : -1)
          }
        })

        rv.observe('addToNew', val => {
          const sForm = spiral.instancesController.getInstance('form', this.find('form'))

          sForm.options.url = `/collections/create/${val ? rv.get('productID') : ''}`
        }, { init: false })

        rv.on('delete', (ev, i) => {
          ev.original.preventDefault()

          spiral.ajax({
            url: `/collections/delete/${ev.context.id}`,

            processAnswer (result) {
              if (!result.isSuccess || result.response.status !== 200) {
                return
              }

              rv.splice('collections', i, 1)
            },
          })
        })
      },
    })
  }

  bindAjax (id, productType, cb) {
    const that = this

    const isPersonalProductType = (productType === 'personal' ? 1 : null)
    const isDPProductType = (productType === 'dp' ? 1 : null)
    const isIcons8ProductType = (productType === 'icons8' ? 1 : null)

    spiral.ajax({
      url: `/collections/getList/${id}`,
      data: {
        personal: that.isPersonal || isPersonalProductType,
        dp: that.isDepositPhotos || isDPProductType,
        icons8: that.isIcons8 || isIcons8ProductType,
      },
      processAnswer (result) {
        if (that.rv) {
          that.rv.set('collections', result.response.collections)
          that.rv.set('savedCollections', $.extend(true, {}, result.response.collections))
          that.collections = that.rv.get('collections')
        } else {
          that.collections = result.response.collections
        }

        cb()
      },
    })
  }
}
